import React from 'react';

export const Contact = () => {
  return (
    <div className="p-8 mt-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-4xl font-extrabold mb-6 text-center text-gray-800">Contact Us</h1>
      <div className="space-y-2 text-lg text-gray-700">
   
      
      
        
        <p><span className="font-bold">MANISH LODHA:</span> +91 94262 58092</p>
        <p><span className="font-bold">PRITESH LODHA:</span> +91 87640 09531</p>
        <p><span className="font-bold">BHUPESH LODHA:</span> +91 98293 91401</p>
        
        <div className="mt-6">
          <p className="text-xl font-bold">HEAD OFFICE</p>
          <p>1473, BUMB SADAN 1st, PARTANIYON KA RASTA JOHARI BAZAR, JAIPUR (RAJ.) - 302003</p>
          
          <p><span className="font-bold">Email:</span> <a href="mailto:shreejewels0904@gmail.com" className="text-blue-600 hover:underline">shreejewels0904@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
